/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module SharedstorageTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface SharedStorage {
    [k: string]: any;
}
/**
 * This interface was referenced by `SharedStorage`'s JSON-Schema
 * via the `definition` "ReadParameters".
 */
export interface ReadParameters {
    /**
     * List of json nodes in order of hierarchy starting from root
     */
    path: string[];
}
/**
 * This interface was referenced by `SharedStorage`'s JSON-Schema
 * via the `definition` "ReadReturn".
 */
export interface ReadReturn {
    [k: string]: any;
}
/**
 * This interface was referenced by `SharedStorage`'s JSON-Schema
 * via the `definition` "WriteParameters".
 */
export interface WriteParameters {
    /**
     * List of json nodes in order of hierarchy starting from root
     */
    path: string[];
    data: data;
}
export interface data {
    [k: string]: any;
}
/**
 * This interface was referenced by `SharedStorage`'s JSON-Schema
 * via the `definition` "RemoveParameters".
 */
export interface RemoveParameters {
    /**
     * List of json nodes in order of hierarchy starting from root
     */
    path: string[];
}
/**
 * This interface was referenced by `SharedStorage`'s JSON-Schema
 * via the `definition` "PostCacheUpdateParameters".
 */
export interface PostCacheUpdateParameters {
    operationType: OperationType;
    /**
     * List of json nodes in order of hierarchy starting from root
     */
    path: string[];
    cacheUpdateData?: cacheUpdateData;
}
export interface cacheUpdateData {
    [k: string]: any;
}
/**
 * This interface was referenced by `SharedStorage`'s JSON-Schema
 * via the `definition` "CacheReturn".
 */
export interface CacheReturn {
    [k: string]: any;
}

export enum OperationType {
    Read = 'Read',
    Write = 'Write',
    Remove = 'Remove',
    Cache = 'Cache'
}


}
